import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {select, call} from 'typed-redux-saga';

import {CriteriaDefinition} from 'api/gen/CriteriaDefinition';
import {Sex} from 'api/gen/Sex';
import {State} from 'app/setup';

import {matingBullsFilterFormName} from '../../types/mating-bulls-filter-form-values';
import {matingCowsFilterFormName} from '../../types/mating-cows-filter-form-values';
import {ResetSingleCriteriaValueAction} from '../action';
import {MatingFormName, resetCriteriaValues} from './reset-criteria-values-saga-utils';

interface ResetContext {
    criteriaDefinitions: Array<CriteriaDefinition>;
    formName: MatingFormName;
}

function* getResetContext(sex: Sex): SagaIterator<ResetContext> {
    if (sex === 'FEMALE') {
        const criteriaDefinitions = (yield* select((state: State) => state.mating.cowCriteriaDefinitions))
            .orCrash('criteria definitions not available');
        return {criteriaDefinitions, formName: matingCowsFilterFormName};
    }

    const criteriaDefinitions = (yield* select((state: State) => state.mating.bullCriteriaDefinitions))
        .orCrash('criteria definitions not available');

    return {criteriaDefinitions, formName: matingBullsFilterFormName};
}

export function* execute(
    {payload: {sex, criteriaCode}}: ResetSingleCriteriaValueAction,
): SagaIterator {
    const {criteriaDefinitions, formName} = yield* call(getResetContext, sex);
    const resetCriteriaDefinitions = criteriaDefinitions.filter(x => x.code === criteriaCode);

    yield* call(resetCriteriaValues, formName, resetCriteriaDefinitions, true);
}

/** Saga that handles `mating/RESET_SINGLE_CRITERIA_VALUE`. */
export function* resetSingleCriteriaValueSaga(): SagaIterator {
    yield takeLatestF('mating/RESET_SINGLE_CRITERIA_VALUE', execute);
}
